import React from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router';
import { t } from 'ttag';
import { LearnerPretestStatus } from '~/data';
import { formatDocumentTitle } from '~/lib/a11y/formatDocumentTitle';
import { select } from '~/lib/select';
import { TrainingState, useTrainingStore } from '../state';
import { useTrainingUrl } from '../useTrainingUrl';
import { PretestIntro } from './PretestIntro';
import { PretestQuestions } from './PretestQuestions';
import { PretestResults } from './PretestResults';

const selector = (s: TrainingState) =>
  select(s, 'pretest', 'title', 'pretestExitRoute');

/**
 * The pretest page. It shows the screen for the pretest's status, so the
 * intro, the questions and the results follow whatever the server last said.
 */
export const Pretest = () => {
  const { pretest, title, pretestExitRoute } = useTrainingStore(selector);
  const url = useTrainingUrl() ?? '';

  // No pretest applies: the course decides where to go.
  if (!pretest) return <Redirect to={url} />;

  if (pretest.status === LearnerPretestStatus.Declined) {
    return <Redirect to={`${url}/${pretestExitRoute()}`} />;
  }

  let screen = <PretestIntro />;
  if (pretest.status === LearnerPretestStatus.InProgress) {
    screen = <PretestQuestions />;
  } else if (pretest.status === LearnerPretestStatus.Completed) {
    screen = <PretestResults />;
  }

  return (
    <>
      <Helmet>
        <title>{formatDocumentTitle(title, t`Pretest`)}</title>
      </Helmet>
      {screen}
    </>
  );
};
